// Links, buttons, or forms (button_to renders a form):
// <%= button_to "Remove", path, method: :delete, form: { data: { behavior: "confirm", confirm: "Remove?" } } %>
export default function confirm(el) {
  const event = el.tagName === "FORM" ? "submit" : "click"

  el.addEventListener(event, (e) => {
    if (!window.confirm(el.dataset.confirm || "Are you sure?")) {
      e.preventDefault()
      e.stopImmediatePropagation()
    }
  })
}
